import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e41c6a3c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41c6a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e41c6a3c')) {
      api.createRecord('e41c6a3c', component.options)
    } else {
      api.reload('e41c6a3c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e41c6a3c&scoped=true&", function () {
      api.rerender('e41c6a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4WYqt2giWG0HR/JS/comp/Accordion.vue"
export default component.exports